import {useMatchMedia} from '@pexip/hooks';

import {TOUCH_DEVICE} from '../../constants/mediaQueries';

export const useTouchDevice = () => useMatchMedia(TOUCH_DEVICE);
